import { createFileRoute } from "@tanstack/react-router";
import { SandboxNew } from "../../features/sandboxes/sandbox-new";

export const Route = createFileRoute("/_authed/$org/$project/sandboxes/new")({
  component: NewSandboxPage,
});

function NewSandboxPage() {
  const { org, project } = Route.useParams();
  return <SandboxNew scope={{ org, project }} />;
}
